import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import SocialAPIUtils from "../utils/SocialAPIUtils";
import { SEARCH_TOPICS_BEGIN, searchTopicsSuccess, logError } from "../actions";
export default function searchTopicsEpic(action$, state$) {
    return action$.pipe(ofType(SEARCH_TOPICS_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.searchTopics(action.options)).pipe(switchMap(function(topics) {
            return [
                searchTopicsSuccess({
                    topics: topics,
                    notes: action.options.notes
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "search_topics"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "search_topics"
        }));
    }));
}
